import {
  MessageCircleQuestionMark,
  Files,
  Scroll,
  Newspaper,
  ChartNoAxesCombined
} from 'lucide-react'

export const SEARCH_TYPE_ICONS = {
  'icon-qa-search-variant': MessageCircleQuestionMark,
  'icon-documents-search-variant': Files,
  'icon-legislation-search-variant': Scroll,
  'icon-news-archive-search-variant': Newspaper,
  'icon-markets-search-variant': ChartNoAxesCombined
}

export const SEARCH_TYPE_NAMES = {
  qa: 'Q&A',
  documents: 'Documents',
  legislation: 'Legislation',
  ca: 'News',
  dealwatch: 'Markets'
}

export const SEARCH_TYPE_ICONS_MAP = {
  qa: MessageCircleQuestionMark,
  documents: Files,
  legislation: Scroll,
  ca: Newspaper,
  dealwatch: ChartNoAxesCombined
}
